export const environment = {
  production: true,
  PathAPI: 'https://claimapiexternal.policybazaar.com/',
  PathClaimsAPI: 'https://claimapi.policybazaar.com/',
  PathURL:'https://claimsurvey.policybazaar.com/v2/#/',
  env: '',
  authKey: ''
};
